import { createFileRoute, useParams } from "@tanstack/react-router";
import { EMPTY_ORG_ID } from "@/constants/org";
import { EntityTypeFormTab } from "@/features/form-editor/components/entity-type-form-tab";

const ROUTE_ID =
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/schema" as const;

export const Route = createFileRoute(ROUTE_ID)({
	component: AdminAssetTypeSchemaTab,
});

function AdminAssetTypeSchemaTab() {
	const { assetTypeId } = useParams({ from: ROUTE_ID });
	return (
		<EntityTypeFormTab
			entity="asset"
			typeId={assetTypeId}
			scope="admin"
			mutationOrganizationId={EMPTY_ORG_ID}
		/>
	);
}
